<template lang="pug">
section.filters.mb-5(v-if="showBlock")
    header.header-5.mb-4.align-items-baseline
        | Фильтры
        button.btn.btn-link.p-0.ms-2.text-decoration-none(
            v-if="activeFiltersIds.length",
            @click="clearFilters",
            style="font-size: 0.8rem; line-height: 1"
        ) Сбросить
    .card__tags.mb-4(v-if="activeFilters.length")
        span.b-tag.-closable(
            v-for="(filter, idx) in activeFilters"
            :key="idx" @click="handleFilterChange(filter.id)"
            :style="{background:getTagColour(filter.id)}"
        ) {{filter.title}}
    b-row.mb-5(
            v-for="(filter, filterType) in filtersByVisibility"
            :key="`filters-list-${filterType}`"
            v-if="filter.items.length"
        )
        b-col(cols="12")
            header.label-2.mb-3 {{ filter.title }}
            .checkbox(
                is="label"
                v-for="(item, idx) in filter.sortedItems.visible"
                :key="`filter-${item.id}-item`"
            )
                input(
                    type="checkbox",
                    :checked="activeFiltersIds.includes(item.id)",
                    @change="handleFilterChange(item.id)"
                )
                span {{ item.title }}
                    span.ms-2.text--grey {{ item.occurances }}
            
            b-collapse.mt-2(v-if="filter.sortedItems.hidden.length" :id="`collapsed-filters-${filterType}`")
                .checkbox(
                    is="label"
                    v-for="(item, idx) in filter.sortedItems.hidden"
                    :key="`filter-${item.id}-item`"
                )
                    input(
                        type="checkbox",
                        :checked="activeFiltersIds.includes(item.id)",
                        @change="handleFilterChange(item.id)"
                    )
                    span {{ item.title }}
                        span.ms-2.text--grey {{ item.occurances }}

            button.btn.mt-2.btn-link.p-0.text-decoration-none(
                v-if="filter.sortedItems.hidden.length",
                v-b-toggle="`collapsed-filters-${filterType}`",
                @click="$event.target.innerText = $event.target.innerText === 'Показать все' ? 'Свернуть' : 'Показать все'"
            ) Показать все
</template>

<script>
import { mapMutations } from "vuex";

export default {
    name: "FiltersComponent",
    props: {
        filters: { required: true, type: Object, default: () => ({}) },
    },
    data: () => ({
        itemsToShow: 5,
    }),
    computed: {
        activeFiltersIds() {
            return this.$store.state.filterQuery
                ? this.$store.state.filterQuery
                : [];
        },
        activeFilters() {
            const activeFilters = [];
            Object.keys(this.filters).forEach((filterType) => {
                this.filters[filterType].items.forEach((filter) => {
                    if (this.activeFiltersIds.includes(filter.id))
                        activeFilters.push(filter);
                });
            });
            return activeFilters;
        },
        showBlock() {
            return (
                this.filters &&
                Object.keys(this.filters).some(
                    (filter) => this.filters[filter].items.length
                )
            );
        },
        filtersByVisibility() {
            const filters = {};
            Object.keys(this.filters).forEach((filterType) => {
                filters[filterType] = Object.assign(
                    {},
                    this.filters[filterType]
                );
                filters[filterType].sortedItems = { visible: [], hidden: [] };
                filters[filterType].items.forEach((item, idx) => {
                    if (idx + 1 <= this.itemsToShow) {
                        filters[filterType].sortedItems.visible.push(item);
                    } else {
                        filters[filterType].sortedItems.hidden.push(item);
                    }
                });
            });
            return filters;
        },
    },
    methods: {
        ...mapMutations([
            "setSearchQuery",
            "setFilterQuery",
            "setSearchInputOpen",
        ]),
        handleFilterChange(id) {
            if (this.$router.history.current.path != "/") {
                this.$router.push("/");
            }

            if (this.activeFiltersIds.includes(id)) {
                this.activeFiltersIds.splice(
                    this.activeFiltersIds.indexOf(id),
                    1
                );
            } else {
                this.activeFiltersIds.push(id);
            }
            this.setSearchQuery(null);
            this.setSearchInputOpen(false);
            this.setFilterQuery(
                this.activeFiltersIds.length ? this.activeFiltersIds : null
            );
            this.$emit("change", this.activeFiltersIds);

            window.scrollTo({ top: 0, behavior: "instant" });
        },
        clearFilters() {
            this.setFilterQuery(null);
        },
        getTagColour(tagId) {
            let colour = "";
            const filters = this.filters;
            Object.keys(filters).forEach((filterType) => {
                if (
                    filters[filterType].items.map((i) => i.id).includes(tagId)
                ) {
                    colour = filters[filterType].colour;
                }
            });
            return colour;
        },
    },
};
</script>
